export default "__VITE_ASSET__0cTy_48H__"